// @flow
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserId } from '../stores/auth';
import { setInitialState as setInitialPaymentState } from '../stores/payments';
import { setInitialState as setInitialVehicleState } from '../stores/vehicle';
import { clearSensitiveData as clearMonthlyData } from '../stores/monthlyCheckout';

const useClearDataOnLogout = () => {
  const dispatch = useDispatch();

  const userId = useSelector(selectUserId);

  useEffect(
    () => () => {
      if (userId !== undefined) {
        dispatch(setInitialPaymentState());
        dispatch(setInitialVehicleState());
        dispatch(clearMonthlyData());
      }
    },
    [dispatch, userId]
  );
};

export default useClearDataOnLogout;
